import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";

const CustomPaginationButton = ({ title, disabled, active, onClick }) => {
  const [itemHovered, setItemHovered] = useState(false);

  return (
    <Button
      className={`${
        active || itemHovered ? "bg-primary" : "bg-white border-grey text-black"
      } ms-2 me-1 me-md-2 rounded p-2 px-3 `}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setItemHovered(true)}
      onMouseLeave={() => setItemHovered(false)}
    >
      {title}
    </Button>
  );
};

const PaginationComponent = ({
  page,
  setPage,
  totalItems,
  itemsPerPage,
  fetchRecords,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (i) => {
    setPage(i);
    fetchRecords(i);
  };

  const handlePreviousClick = () => {
    if (page > 1) {
      handlePageChange(page - 1);
    }
  };

  const handleNextClick = () => {
    if (page < totalPages) {
      handlePageChange(page + 1);
    }
  };

  const handleFirstClick = () => {
    handlePageChange(1);
  };

  const handleLastClick = () => {
    handlePageChange(totalPages);
  };

  const getPageNumbers = () => {
    let startPage, endPage;

    if (totalPages >= 5) {
      startPage = Math.max(1, page - 2);
      endPage = Math.min(totalPages, page + 2);
    } else {
      startPage = 1;
      endPage = totalPages;
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <CustomPaginationButton
        onClick={handleFirstClick}
        disabled={page === 1}
        title={
          <>
            <span className="d-none d-md-block">First</span>
            <span className="d-block d-md-none">
              <MdKeyboardDoubleArrowLeft />
            </span>
          </>
        }
      />
      <CustomPaginationButton
        onClick={handlePreviousClick}
        disabled={page === 1}
        title={
          <>
            <span className="d-none d-md-block">
              <FaArrowLeft className="mx-1" /> Previous
            </span>
            <span className="d-block d-md-none">
              <MdKeyboardDoubleArrowLeft />
            </span>
          </>
        }
      />
      {getPageNumbers().map((pageNumber) => (
        <CustomPaginationButton
          key={pageNumber}
          onClick={() => handlePageChange(pageNumber)}
          active={pageNumber === page}
          title={`${pageNumber}`}
        />
      ))}
      <CustomPaginationButton
        onClick={handleNextClick}
        disabled={page === totalPages}
        title={
          <>
            <span className="d-none d-md-block">
              Next <FaArrowRight className="mx-1" />
            </span>
            <span className="d-block d-md-none">
              <MdKeyboardDoubleArrowRight />
            </span>
          </>
        }
      />
      <CustomPaginationButton
        onClick={handleLastClick}
        disabled={page === totalPages}
        title={
          <>
            <span className="d-none d-md-block">Last</span>
            <span className="d-block d-md-none">
              <MdKeyboardDoubleArrowRight />
            </span>
          </>
        }
      />
    </div>
  );
};

export default PaginationComponent;
